import { AnswerCardLang } from './card/answerCard.lang';

export const AnswerListLang = {
    searchBoxPH: 'کد پاسخنامه را وارد کنید',
    noAnswer: 'برای این فرم پرسشگر پاسخی ثبت نشده است',
    answerCard: AnswerCardLang,
};
